import axios from 'axios';
import axiosRetry from 'axios-retry';
import { axiosRetryConfig } from "./axiosRetry";

import { API_URL, API_KEY } from '../config';
import * as Sentry from "@sentry/react";
import { getAuthToken } from "./auth";

const maskSensitiveData = (s: string, start: number, end: number) => {
    //make sure the string is long enough - if it isn't, then it isn't a proper Bearer token, so just return it all, to help debugging
    if (s.length < start + end) {
        return s;
    }
    return s && (s.slice(0, start) + "*".repeat(s.length - (start + end)) + s.slice(s.length - end, s.length));
}

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "x-api-key":API_KEY, "content-type": "application/json" }
});

axiosRetry(axiosInstance, axiosRetryConfig);

axiosInstance.interceptors.request.use(async apiConfig => {
        const token = await getAuthToken();
        let newHeaders = apiConfig.headers || {};
        if (token) {
            // @ts-ignore
            newHeaders = {
                ...newHeaders,
                Authorization: `Bearer ${token}`
            }
        }
    if(apiConfig.url?.includes('customers/users/v1') && Sentry) {
        Sentry.addBreadcrumb({
            category: "sentry.event",
            message: `Tken len: ${token?.length} . Ath head len: ${String(newHeaders.Authorization)?.length}`,
            level: "info",
        });
    }

    return { ...apiConfig, headers: newHeaders }
    }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error({
      message: error.message,
      headers: JSON.stringify({
        apiMaskedKey: maskSensitiveData(error.config?.headers['x-api-key'], 2, 3),
        accept: error.config?.headers?.Accept,
        contentType: error.config?.headers['Content-Type'],
        maskedBearer: maskSensitiveData(error.config?.headers?.Authorization, 9, 3)
      }),
      response: JSON.stringify(error.response?.__sentry_xhr__),
      request: JSON.stringify(error.request?.__sentry_xhr__)
    });
    Sentry.captureException(new Error(`Request error: ${error.request?.__sentry_xhr__?.method} ${error.request?.__sentry_xhr__?.url}`))
    return Promise.reject((error.response && error.response.data) || error.message || (typeof error === "string" && error) || 'Something went wrong')
  }
);

export default axiosInstance;
